import React, { useEffect, useState } from "react";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Hero from "./Hero";
import Article from "./Article";
import { useRouteMeta } from "./hooks/useRouteMeta"; // 👈 add this

const SpecialsPage = () => {
  const [specialsData, setSpecialsData] = useState([]);
  const [heroImage, setHeroImage] = useState("");
  const [loading, setLoading] = useState(true);

  // ✅ Load meta tags for this page from MetaTags/Promotions
  useRouteMeta("Promotions", {
    metaTitle: {
      en: "Promotions | My Company",
      fr: "Promotions | Mon entreprise",
    },
    metaDescription: {
      en: "Discover our current promotions and special offers.",
      fr: "Découvrez nos promotions et offres spéciales en cours.",
    },
    metaOgTitle: {
      en: "Promotions | My Company",
      fr: "Promotions | Mon entreprise",
    },
    metaOgDescription: {
      en: "Limited-time promotions and special deals just for you.",
      fr: "Promotions limitées et offres spéciales pour vous.",
    },
    metaOgImage: "https://example.com/og-promotions.jpg",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // 👇 Fetch hero background
        const heroDoc = await getDoc(doc(db, "hero", "specials"));
        if (heroDoc.exists()) {
          const url = heroDoc.data().imageUrl?.trim();
          console.log("✅ Hero background image URL:", url);
          setHeroImage(url);
        } else {
          console.warn("❌ No hero document found.");
        }

        // 👇 Fetch promotional articles
        const promotionsSnapshot = await getDocs(collection(db, "promotions"));
        const allArticles = [];

        for (const promoDoc of promotionsSnapshot.docs) {
          const articlesRef = collection(db, "promotions", promoDoc.id, "articles");
          const articlesSnapshot = await getDocs(articlesRef);

          const articles = articlesSnapshot.docs
            .map((doc) => ({ id: doc.id, ...doc.data() }))
            .filter(
              (item) =>
                Array.isArray(item.imageUrl) &&
                item.imageUrl.length > 0 &&
                typeof item.imageUrl[0] === "string"
            );

          allArticles.push(...articles);
        }

        setSpecialsData(allArticles);
      } catch (error) {
        console.error("Error loading specials page:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Hero backgroundImage={heroImage} />
      {loading ? (
        <p className="text-center py-10">Loading promotions...</p>
      ) : (
        <Article
          data={specialsData}
          title="Promotions"
          style={{ backgroundColor: "#f0f0f0" }}
        />
      )}
    </>
  );
};

export default SpecialsPage;
